import React, { useId } from "react";

const ToggleUnlock = ({ isChecked, handleToggle, data }) => {
  const id1 = useId();
  const handleLocalChange = (e) => {
    handleToggle(e, data);
  };

  return (
    <>
      <div className="toggle-button-wrapper">
        <button
          id={id1}
          type="button"
          className={`toggle-button ${isChecked ? "active" : ""}`}
          aria-pressed={isChecked}
          aria-label={`Unlock User ${data?.client?.full_name}'s Account`}
          onClick={(e) => handleLocalChange(e)}
        ></button>
      </div>
    </>
    // <div className="unlock_toggle_btn">
    //   <input
    //     id={id1}
    //     name={name && name}
    //     type="checkbox"
    //     checked={isChecked}
    //     onChange={(e) => {
    //       handleLocalChange(e);
    //     }}
    //     className="visually-hidden"
    //
    // />
    //   <label htmlFor={id1}>
    //     <span className="label-name">{`Unlock User ${data?.client?.full_name}'s Account`}</span>
    //   </label>
    // </div>
  );
};

export default ToggleUnlock;
